import { z } from "zod";

export const payBreakdownLineSchema = z.object({
  category: z.string(),
  hours: z.number(),
  rate: z.number(),
  multiplier: z.number(),
  amount: z.number(),
  description: z.string(),
  isSiteCost: z.boolean().optional(),
});

export const recalculatePayPeriodParamsSchema = z.object({
  payPeriodId: z.string().uuid(),
});

export const recalculatePayPeriodBodySchema = z.object({
  async: z.boolean().default(true),
  workerId: z.string().uuid().optional(),
});

export const recalculatePayPeriodResponseSchema = z.object({
  queued: z.boolean(),
  payPeriodId: z.string().uuid(),
  workerId: z.string().uuid().nullable(),
  recalculatedCount: z.number().int().optional(),
});

export type PayBreakdownLine = z.infer<typeof payBreakdownLineSchema>;
export type RecalculatePayPeriodBody = z.infer<typeof recalculatePayPeriodBodySchema>;
export type RecalculatePayPeriodResponse = z.infer<typeof recalculatePayPeriodResponseSchema>;
